import React, {useState} from 'react'

import {styles} from '../styles'

import {LoadingOutlined} from '@ant-design/icons'

import Avatar from '../Avatar'

import axios from 'axios'
const EmailForm = props => {

const [email, setEmail] = useState('')
const [loading, setLoading] = useState(false)


function getOrCreateUser(callback){
        axios.put(
                'https://api.chatengine.io/users/',
                {
                        username:email,
                        secret:email,
                        email:email
                },
                {headers:{"Private-Key":process.env.REACT_APP_PRIVATE_KEY}}
        )

        .then(r => callback(r.data))
        .catch(e => console.log("Get or create user error", e))
}


function getOrCreateChat(callback){
        axios.put(
                'https://api.chatengine.io/chats/',
                {
                        usernames:[email,'dao'],
                        "is_direct_chat":true
                },
                {headers:{"Project-ID":process.env.REACT_APP_CLIENT_ID,
                "User-Name":email,
                "User-Secret":email,        
        }}
        )

        .then(r => callback(r.data))
        .catch(e => console.log("Get or create chat error", e))
}



function handleSubmit(event) {
        // stops the page from reloading automatically
        event.preventDefault();


        setLoading(true)

        console.log('Sending Email', email)



        getOrCreateUser(
                user => {
                        props.setUser(user) && props.setUser(user)
                        getOrCreateChat(
                        chat => {
                                setLoading(false)

                                props.setChat && props.setChat(chat)

                        })
                }
        )
}


return(

<div

    style={{
        ...styles.emailFormWindow,
        ...{height: props.visible ? '100%' : '0%',opacity:props.visible ? '1' : '0',
}



}}

>


<div style={{
        height:'0px'
}}
>


<div style={styles.stripe}/>


</div>


<div
        className='transition-5'
        style={{
                ...styles.loadingDiv,
                ...{
                        zIndex: loading ? '10' : '-1',
                        opacity: loading ? '0.33' : '0'
                }
        }}
/>


<LoadingOutlined
        className="transition-5"
        style={{
                zIndex: loading ? '10' : '-1',
                opacity: loading ? '1' : '0',
                fontSize: '82',
                top: 'calc(50%- 41px)',
                left: 'calc(50% - 41px)',


        }}

        />










<div style={{
        position:"absolute", height:'100%', width:'100%', textAlign:'center'
}}
>
{/* This is putting the avatar in the window when used */}
<Avatar
        style={{
                position: 'relative',
                left: 'calc(50%)',
                top:'10%',

        }}

/>








<div style={styles.topText}>

        Welcome to my <br/>support widget!





</div>









<form onSubmit={(e => handleSubmit(e))}
        style={{
                position:'relative', 
                width:'100%',
                top: '19.75'
        }}


>
{/* end form open tag */}

{/* I need three fucking screens back, this shit is ridiculous with 2 only. Even 5 was badass. FUCK */}

<input

        style={styles.emailInput}
        onChange={e => setEmail(e.target.value)}
        placeholder='Your Email'

/>






</form>


<div style={styles.bottomText}>

Enter your email<br/>
to get started.




</div>








</div>






</div>

)



}


export default EmailForm;